import React, { useState, useEffect } from 'react';
import {
  OfferSectionContainer,
  OfferSectionHeader,
  OfferSectionBody,
  OfferTable,
  EventCreatorProfile,
  EventUserProfile,
  EventActionProfile,
  FilterWrapper,
  TitleWrapper,
  PaginationWrapper
} from './styles';
import { Pagination } from '../Pagination';
import { useTheme } from 'styled-components';
import { EmptyActivityIcon, ActionCheckIcon, ActionCloseIcon, BellInActiveIcon } from '../SvgIcons';
import { useGlobal } from '../../../contexts/GlobalContext';
import { useCustomWallet } from '../../../contexts/WalletContext';
import { useParams, useNavigate } from 'react-router-dom';
import eventCreatorAvatar from '../../../assets/images/EventCreatorAvatar.png';
// import { useContract } from '../../../contexts/ContractContext';
import useToast from '../../../hooks/useToast';
// import { useAuth } from '../../../contexts/AuthContext';
import GradientButton from '../GradientButton';

const Notifications = (props) => {
  const {
    limit,
    isHeader,
    handleActiveSection,
    userAddress
  } = props

  // const { auth } = useAuth();
  const theme = useTheme();
  // const { address } = useParams()
  // const { removeOffer, acceptOffer } = useContract()
  const { showLoading, hideLoading, toastInfo, toastSuccess, toastError } = useToast();

  // const [offerList, setOfferList] = useState([])
  const [offerListRows, setOfferListRows] = useState([])
  const navigate = useNavigate()
  const { wallet, getWalletAddressBySessionKey } = useCustomWallet()
  const [notItems, setNotItems] = useState([])

  const { invokeServer } = useGlobal();

  const [selectedFilterItem, setSelectedFilterItem] = useState('all')
  const [paginationProps, setPaginationProps] = useState({
    page_size: 10,
    current_page: 1
  })

  const filterList = [
    { key: 'all', name: 'ALL' },
    { key: 0, name: 'BUY' },
    { key: 1, name: 'SALE' },
    { key: 2, name: 'BID MADE' },
    { key: 3, name: 'BID RECEIVED' },
    { key: 4, name: 'OFFER MADE' },
    { key: 5, name: 'OFFER RECEIVED' }
  ]

  const handleChangePage = (pageNumber) => {
    getNotificationList(pageNumber, 10)
  }

  useEffect(() => {
    getNotificationList(paginationProps.current_page, 10);
  }, [selectedFilterItem])

  const getNotificationList = (page, page_size) => {
    let params = limit
      ? `address=${(getWalletAddressBySessionKey())}&page=1&page_size=${limit}&limit=${limit}`
      : `address=${(getWalletAddressBySessionKey())}&page=${page}&page_size=${page_size}`
    if (selectedFilterItem !== 'all') params = `${params}&eventType=${selectedFilterItem}`

    invokeServer('get', `/api/notification?${params}`)
      .then(r => {
        if (r.data.items !== undefined && JSON.stringify(r.data.items) !== JSON.stringify(notItems)) {
          setNotItems(t => r.data.items);
          setPaginationProps(r.data.pagination)
        }
        if (isHeader) setTimeout(getNotificationList, 10000);
      })
      .catch(err => {
        console.log(`${err.message}`);
        if (isHeader) setTimeout(getNotificationList, 3000);
      })
  }

  const renderItemField = (item) => {
    let nftAvatar = item?.nftImage || eventCreatorAvatar
    let nftName = item?.nftTitle
    let creator = item?.creatorName || ''
    const address = item?.to || item?.from

    return (
      <EventCreatorProfile>
        <img src={nftAvatar} alt='nft' />
        <div>
          <div className="title">{creator}</div>
          <div className="value" onClick={() => address && handleClickAddress(address)}>{nftName}</div>
        </div>
      </EventCreatorProfile>
    )
  }

  const renderPriceField = (activity) => {
    switch (activity.paymentName) {
      case 'HyperX':
        return (
          <div className="price-div">
            <img src={theme.images.chainTokenIcon} alt='hyperX' />
            <div>{activity.price}</div>
          </div>
        )
      case 'BNB':
        return (
          <div className="price-div">
            <img src={theme.images.binanceTokenIcon} alt='bnb' />
            <div>{activity.price}</div>
          </div>
        )
      case 'BUSD':
        return (
          <div className="price-div">
            <img src={theme.images.binanceUsdIcon} alt='busd' />
            <div>{activity.price}</div>
          </div>
        )
      default:
        return (
          <div className="price-div">
            <div>{activity.basePrice} {activity.paymentName}</div>
          </div>
        )
    }
  }

  const handleClickAddress = (address) => {
    navigate(`/profile/${address}`)
    handleActiveSection('grid')
  }

  const renderUser = (item, flag) => {
    let userAvatar = (flag ? item?.fromAvatar : item?.toAvatar) || '/images/profile-user-1.png';
    const address = flag ? item?.from : item?.to
    let isValid = false
    if (flag) {
      isValid = item?.fromAvatar || item?.fromName
    } else {
      isValid = item?.toAvatar || item?.toName
    }
    return (
      <>
        {isValid && (
          <EventUserProfile noClick={!address}>
            <img src={userAvatar} alt='nft' />
            <div>
              <div className="value"  onClick={() => address && handleClickAddress(address)}>{(flag ? item?.fromName : item?.toName) || '---'}</div>
            </div>
          </EventUserProfile>
        )}
      </>

    )
  }

  const renderActions = (ofr) => {
    return (
      <EventActionProfile>
        <div onClick={() => handleRemoveNotification(ofr)}><ActionCloseIcon /></div>
      </EventActionProfile>
    )
  }

  const renderType = (type) => {
    if (type === 0) return 'Buy'
    if (type === 1) return 'Sale'
    if (type === 2 || type === 3) return 'Bids'
    if (type === 4 || type === 5) return 'Offers'
    return 'Buy'
  }

  useEffect(() => {
    if (notItems.length > 0) {
      setOfferListRows(allRows =>
        notItems.map(notification => {
          return (
            <tr key={notification._id}>
              <td>{renderType(notification?.eventType)}</td>
              <td>{renderItemField(notification)}</td>
              <td>{renderPriceField(notification)}</td>
              <td>{notification.quantity}</td>
              <td>{renderUser(notification, true)}</td>
              <td>{renderUser(notification, false)}</td>
              <td>{notification.timespan}</td>
              <td>{renderActions(notification)}</td>
            </tr>
          )
        })
      )
    } else {
      setOfferListRows(allRows => []);
    }
  }, [notItems])

  const handleRemoveNotification = async (item) => {
    invokeServer('delete', `/api/notification/${item._id}`)
    .then(r => {
      console.log(r)
      if (r.data.result === 1) {
        toastSuccess('Notifications', r.data.msg)
        const updatedNotItems = notItems.filter(notify => notify._id !== item._id)
        setNotItems(updatedNotItems)
      } else {
        toastInfo('Notifications', r.data.msg)
      }
    })
    .catch(err => {
      console.log(`${err.message}`);
      toastError('Notifications', err.message)
    })
  }

  return (
    <OfferSectionContainer>
      <OfferSectionHeader>
        <TitleWrapper>
          <BellInActiveIcon />
          <div className="header-text">Notifications</div>
        </TitleWrapper>
        <FilterWrapper>
          {filterList.map(item => (
            <GradientButton
              key={item.key}
              isNoPadding
              width='140px'
              height='40px'
              label={item.name}
              isBlackMode={selectedFilterItem !== item.key}
              isDarkMode={selectedFilterItem !== item.key}
              handleClick={() => setSelectedFilterItem(item.key)}
            />
          ))}
        </FilterWrapper>
      </OfferSectionHeader>
      <OfferSectionBody>
        <OfferTable>
          <table>
            <thead>
              <tr>
                <th>Event</th>
                <th>Items</th>
                <th>Price</th>
                <th>Quantity</th>
                <th>From</th>
                <th>To</th>
                <th>Time</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {offerListRows.length > 0 ? offerListRows : (
                <tr>
                  <td colSpan={8} style={{ paddingTop: '100px' }}>
                    <div className="no-result">
                      <EmptyActivityIcon />
                      <div className="empty-text">There Are No notifications Yet</div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </OfferTable>
        <PaginationWrapper>
          <Pagination
            currentPage={paginationProps?.current_page}
            totalPages={paginationProps?.total_pages}
            totalItems={paginationProps?.total}
            handleChangePage={handleChangePage}
          />
        </PaginationWrapper>
      </OfferSectionBody>
    </OfferSectionContainer>
  )
}

export default Notifications;
